import { ScanDataSftpCredentialUpdateInput } from '@occc/graphql';

import { ScanDataSubmissionGroupsUpdateFormValues } from './scan-data-submission-groups-update.types';

export const convertScanDataSubmissionGroupFormValuesToUpdateInput = (
  uuid: string,
  formValues: ScanDataSubmissionGroupsUpdateFormValues,
): ScanDataSftpCredentialUpdateInput => {
  return {
    uuid,
    cpg: formValues.tobaccoCompany,
    host: formValues.sftpDetails.submissionURL,
    name: formValues.name || undefined,
    password: formValues.sftpDetails.password,
    port: formValues.sftpDetails.portNumber
      ? parseInt(formValues.sftpDetails.portNumber, 10)
      : undefined,
    submitterID: formValues.sftpDetails.submitterID,
    username: formValues.sftpDetails.username,
    credentialStatus: formValues.submissionType,
  };
};
